import { render } from "./ViewFormulirPSB.vue?vue&type=template&id=759e3077&scoped=true"
import script from "./ViewFormulirPSB.vue?vue&type=script&lang=js"
export * from "./ViewFormulirPSB.vue?vue&type=script&lang=js"

import "./ViewFormulirPSB.vue?vue&type=style&index=0&id=759e3077&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759e3077"]])

export default __exports__